<template>
  <v-flex xs6 mb-2>
    <v-card @click="seleccionarRespuesta(respuesta)" :class="seen ? 'e-ejercicio-ejercicio-selecionado' : 'algo'" class="e-elevation--3 radius">
      <v-card-text>
        <p class="e-description-middle mb-0 text-xs-center py-5">{{ respuesta }}</p>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "SubCardColumna",
  data () {
    return {
      seen: false,
    }
  },
  props: {
    respuesta: {
      type: String,
      default: ''
    },
    indexRespuesta: {
      type: Number,
      default: 0
    },
    separar: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    seleccionarRespuesta(value) {
      this.seen = !this.seen
      const valueSelected = {
        selected: this.seen,
        value: value
      }
      this.$emit('clicked', valueSelected)
    },
    adicionarEspacio() {
      if(this.separar) {
        const mod = ((this.indexRespuesta + 2) % 2)
        if(mod == 0) {
          return true
        }
      }
      return false
    }
  }
}
</script>
